import { ContextMenu as BaseContextMenu } from '@base-ui/react/context-menu'
import type { PartProps } from '../../../lib/part-props'

interface ContextMenuTriggerProps extends PartProps<BaseContextMenu.Trigger.Props> {}

function ContextMenuTrigger({ children, ...props }: ContextMenuTriggerProps) {
  return <BaseContextMenu.Trigger {...props}>{children}</BaseContextMenu.Trigger>
}

export { ContextMenuTrigger }
